import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const GET_SECURITY_USER_ASSETS_DETAIL = 'GET_SECURITY_USER_ASSETS_DETAIL';

const apiCall = createApiCall(
  GET_SECURITY_USER_ASSETS_DETAIL,
  ({ id, ...params }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/security-user-assets/${id}`,
      params,
    }),
    method: 'GET',
    skipDefaultErrorMessage: true,
  })
);

export default apiCall;
